export default __webpack_public_path__ + "static/media/advantages-01.77c28508.svg";